import React from 'react';
import { Icon } from './Icon.js';
export const IconOctagonInfo = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 16V12H10", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M12 8.01V8", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M15.7757 2.5L8.18868 2.5L2.5 8.18958L2.50011 15.8113L8.18866 21.5L15.7757 21.4999L21.5 15.8113L21.5 8.18858L15.7757 2.5Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconOctagonInfo.js.map